export default "__VITE_ASSET__Z4t7d0Si__"